module.exports = __webpack_public_path__ + "gw.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/gw.svg
// module id = 843
// module chunks = 0